import { find, includes, isEmpty, negate, pickBy } from 'lodash/fp';
import { createSelector } from 'reselect';

import { composeProps, createPropsExtender } from '@mews/framework';

import { getSelectedCityId } from '../../../modules/app/selectors';
import {
    getCityEnterprises,
    getCityEnterprisesIds,
    getCityEnterpriseTimezone,
} from '../../../modules/entities/enterprises/selectors';
import { getDayUseServices } from '../../../modules/entities/services/selectors';

const selectedCityIdPropsExtender = createPropsExtender('cityId', getSelectedCityId);

const getCityDayUseEnterprises = createSelector(
    getCityEnterprises,
    getDayUseServices,
    (enterprises, dayUseBookableServices) =>
        pickBy(({ id: enterpriseId }) => !isEmpty(find({ enterpriseId }, dayUseBookableServices)), enterprises)
);

export const getSelectedCityEnterprises = composeProps(getCityEnterprises, selectedCityIdPropsExtender);

export const getSelectedCityDayUseEnterprises = composeProps(getCityDayUseEnterprises, selectedCityIdPropsExtender);

export const getSelectedCityEnterprisesIds = composeProps(getCityEnterprisesIds, selectedCityIdPropsExtender);

export const getSelectedCityEnterpriseTimezone = composeProps(getCityEnterpriseTimezone, selectedCityIdPropsExtender);

const getSelectedCityDayUseBookableServices = createSelector(
    getSelectedCityEnterprisesIds,
    getDayUseServices,
    (enterpriseIds, bookableServices) =>
        pickBy(({ enterpriseId }) => includes(enterpriseId, enterpriseIds), bookableServices)
);

export const hasSelectedCityDayUseBookableServices = createSelector(
    getSelectedCityDayUseBookableServices,
    negate(isEmpty)
);
